import type { AnalyticSourceParamInput } from '../config/sourceParams';
import { ANALYTIC_SOURCE_PARAM } from '../config/sourceParams';

export type UserSourceResolver = (searchParams: URLSearchParams, paramName: AnalyticSourceParamInput) => string;

function isValidAffiliateToken(value: string): boolean {
  return value.trim().length > 0;
}

export function getFirstSearchParamValue(searchParams: URLSearchParams, paramName: AnalyticSourceParamInput): string {
  const paramNames = Array.isArray(paramName) ? paramName : [paramName];
  return paramNames.map(p => searchParams.get(p)).find(Boolean) ?? '';
}

export function getCampaignIdValue(searchParams: URLSearchParams, paramName: AnalyticSourceParamInput): string {
  const directCampaignId = getFirstSearchParamValue(searchParams, paramName);
  if (directCampaignId) {
    return directCampaignId;
  }

  const utmCampaign = searchParams.get(ANALYTIC_SOURCE_PARAM.UtmCampaign) ?? '';
  const matchId = utmCampaign?.match(/cid(?:\||%7C)(\d+)/i);
  return matchId?.[1] ?? '';
}

export function getAffiliateTokenValue(searchParams: URLSearchParams, paramName: AnalyticSourceParamInput): string {
  const affiliateToken = getFirstSearchParamValue(searchParams, paramName);
  if (isValidAffiliateToken(affiliateToken)) {
    return affiliateToken;
  }

  const fallbackToken = searchParams.get(ANALYTIC_SOURCE_PARAM.Token) || '';
  return isValidAffiliateToken(fallbackToken) ? fallbackToken : '';
}
